import { render } from "./KoruButtonUpload.vue?vue&type=template&id=03a7d494&ts=true"
import script from "./KoruButtonUpload.vue?vue&type=script&lang=ts"
export * from "./KoruButtonUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__